module.exports = __webpack_public_path__ + "img/mail.8fc706c6.svg";